/*
 * @Author: zyy
 * @Date: 2022-07-26 13:29:45
 * @LastEditors: zyy
 * @LastEditTime: 2022-12-07 10:36:04
 * @Description: 门禁
 */
import Axios from 'axios';
import Qs from 'qs';

const modelUrl = "/aliot-laravel/entrance"

export default {

  syncCard(params){
      // return Axios.post('https://aliot.tjb2c.com/api/index/syncCard',params)
      return Axios.post(`${modelUrl}/syncCard`,params)
  }

}